export default {
  productsFrom: "Products from",
  recommendedProducts: "Recommended Products",
};
